import React from "react";
import "./EventPage.css";
import { useEvents } from "../hooks/useEvents";
import InfoCard from "../components/InfoCard";
import EventCardBody from "../components/EventCardBody";
import Hero from "../components/Hero";
import LoadingSpinner from "../components/LoadingSpinner";

const EventPage: React.FC = () => {
  const { data: events, loading, error } = useEvents();

  const activeEvents = events?.filter((event) => {
    const end = new Date(event.eventEndTime);
    if (Number.isNaN(end.getTime())) return false;
    return end.getTime() >= Date.now();
  });

  const sortedEvents = [...(activeEvents ?? [])].sort((a, b) => {
    const timeA = new Date(a.eventStartTime).getTime();
    const timeB = new Date(b.eventStartTime).getTime();

    if (Number.isNaN(timeA) && Number.isNaN(timeB)) return 0;
    if (Number.isNaN(timeA)) return 1;
    if (Number.isNaN(timeB)) return -1;

    return timeA - timeB;
  });

  return (
    <>
      <Hero page="event" titleTwo="Events" />

      <div className="content-container events-container">
        {loading && (
          <div className="info-card">
            <LoadingSpinner />
          </div>
        )}
        {error && (
          <div className="info-card">
            <p>Error: {error}</p>
          </div>
        )}
        {!loading &&
          !error &&
          (!events || events.length === 0 || activeEvents?.length === 0) && (
          <div className="info-card">
            <p>No events available</p>
          </div>
        )}
        {!loading &&
          events &&
          sortedEvents.map((event) => (
            <InfoCard
              key={event.eventName}
              image={event.poster}
              altText={`${event.eventName} poster`}
              body={<EventCardBody event={event} />}
            />
          ))}
      </div>
    </>
  );
};

export default EventPage;
